/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState, useCallback } from "react";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import cssClasses from "./ScanConformationModal.module.css";
import Close from "../../Components/Icons/Close";
import Button from "../../Subcomponents/Button";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import CustomInput from "../../Subcomponents/CustomInput";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import Webcam from "react-webcam";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import {
  addQueueLogs,
  findMaxBandNumber,
  findTotalLeadInGroup,
  findTotalLeadInGroupForThatEvent,
  getLaunchFromEventTokenId,
  getLeadDataFromPaymentId,
  updateLeadDisplayBandNumber,
  updateLeadTokenRelationTable,
  updateLeadTokenRelationTableCheckPoints,
  updateRunningNumber,
} from "../../Services/Queue";
import { addLeadLogs, updateLeadAllStatus } from "../../Services/Lead";
import { groupBy, sumBy } from "lodash";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { useSelector } from "react-redux";
// import { errorTost, successTost } from "../../Services/Toast";
// import { isNativePlatform } from "../../Services/androidImports";
export default function ScanConformationModal({
  open,
  handleClose,
  leadsData,
  qrPresent,
  checksPoint,
  eventId,
  buttonRes,
  launchIds,
  paramLaunchId
}) {
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [webCamModalToggler, setWebCamModalToggler] = useState(false);
  const [respFromQr, setRespFromQr] = useState(null);
  const [bandNumber, setBandNumber] = useState(null);
  const [leadData, setLeadData] = useState({});
  const [leadDataFromScan, setleadDataFromScan] = useState(false);
  const [FlagForDone , setFlagForDone]= useState(false)
  const [checkPoint,setCheckPoint]=useState(1);const [launchId,setLaunchId]=useState(launchIds);

  async function getLaunchIdFromEventTokenId(eventId,eventTokenId) {
    await getLaunchFromEventTokenId(eventId,eventTokenId).then((resp)=>{
     console.log(resp);
     if(resp.data.length>0){
     setLaunchId(resp.data[0]?.launchId)
     }else{
       setLaunchId(launchIds);
     }
   }).catch((error)=>{
     setLaunchId(launchIds);
     console.log(error);
   })
  }
  useEffect(() => {
    setLeadData(leadsData);
    console.log("leadData" , leadsData);
    if(paramLaunchId==="All"){
      getLaunchIdFromEventTokenId(eventId,leadsData?.eventTokenId?.eventTokenId);
    } 
    
    if (qrPresent) {
       setWebCamModalToggler(true);
    }else{
     toCheckBandNumberIsPresent(leadsData);
    }
  }, []);

   function toCheckBandNumberIsPresent(leadData){
    // Todo :Check for checkpt1===false 
    console.log(leadData?.checkpt1);
    if (leadData?.checkpt1 === false) {
      setCheckPoint(1);
      presentLoader();
      toCheckAlgoIsUsed(leadData);
    }else{
      setCheckPoint(2);
    }
    }
  //First check which algo is used
  function toCheckAlgoIsUsed(leadData) {
    console.log('check',leadData);
    console.log(leadData?.eventTokenId?.algoId?.algorithm);
    if (leadData?.eventTokenId?.algoId?.algorithm === "First Pay First") {
    setBandNumber(leadData?.eventTokenId?.tokenId?.shortCode+'-'+parseInt(leadData?.bandNumber));
      updateLeadDisplayBandNumber(leadData?.paymentId,leadData?.eventTokenId?.tokenId?.shortCode+'-'+parseInt(leadData?.bandNumber)).then((resp)=>{
        console.log(resp);
      }).catch((err)=>{
        console.log(err);
      })
      // ** leadStatus updated to CheckPoint One Cleared
      updateLeadAllStatus(leadData?.leadId?.leadId,"Checkpoint One Cleared")
        .then((updatedLeadStatus) => {
          let obj={
            leadId:leadData?.leadId?.leadId,
            leadStatus: `Checkpoint One Cleared`,
            message:`Band Number ${leadData?.eventTokenId?.tokenId?.shortCode+'-'+parseInt(leadData?.bandNumber)} assigned to lead. Checkpoint one Cleared by ${loggedInUser.name}(${loggedInUser?.roleId?.title})`
          }
          addLeadLogs(obj).then((leadLog)=>{console.log(leadLog)}).catch((err)=>{console.log('leadlog',err)})
          console.log(updatedLeadStatus);
         // ** LeadTokenRelationTable updated to CheckPoint1 ===true
          updateLeadTokenRelationTableCheckPoints(leadData?.paymentId,true,false,leadData?.leadId?.leadId,leadData?.eventId , launchId).then((resp)=>{
            console.log(resp);
            let QueueObj = {
              eventId: leadData?.eventId,
              paymentId:leadData?.paymentId,
              launchId:launchId,
              checkPt1:true,
              checkPt2:false,
              leadId:leadData?.leadId?.leadId,
              userId: loggedInUser?.userId,
              bandNumber:leadData?.eventTokenId?.tokenId?.shortCode+'-'+parseInt(leadData?.bandNumber)
            }
            addQueueLogs(QueueObj).then((queueLogResp) => {console.log(queueLogResp)}).catch((err)=>{console.log('queueLogResp',err)})

          }).catch((err)=>{
            console.log(err);
          });
        })
        .catch((err) => {
          console.log(err);
        });
       
      dismissLoader();
      //Update leads status to checkPoint one cleared

      //already got the bandNumber get show the band number !!
    } else if (leadData?.eventTokenId?.algoId?.algorithm === "First Come First") {
      algoFirstComeFirstServe(leadData);
    } else {
      //! For Round robin
      dismissLoader();
      handleClose();
    }
  }
  //! First come First serve
  function algoFirstComeFirstServe(leadData) {
    dismissLoader();
    if (leadData.groupId === null) {
      // ? find max of bandNumber in eventTokenLeadRelation with this eventTokenId and increment that number by 1 and update the current lead's bandNumber
      // ! Find total Leads in grouping
      findTotalLeadInGroupForThatEvent(leadData?.eventId,leadData?.eventTokenId?.eventTokenId)
        .then((totalLeadsInGroup) => {
          console.log({ totalLeadsInGroup });
          let totalLeadInHigherGroup = sumBy(totalLeadsInGroup.data,
            function (o) {
              return o.totalLeadsInGroup;
            }
          );
          findMaxBandNumber(leadData?.eventTokenId?.eventTokenId)
            .then((resp) => {
              console.log(resp[0].num);
              //First Lead 
              if (resp[0].num === null) {
                console.log(totalLeadInHigherGroup + 1);
                updateLeadTokenRelationTable(
                  leadData?.paymentId,
                  totalLeadInHigherGroup + 1,
                  leadData?.eventTokenId.tokenId?.shortCode +
                    "-" +
                    parseInt(totalLeadInHigherGroup + 1)
                )
                  .then((response) => {
                    setBandNumber(
                      leadData?.eventTokenId.tokenId?.shortCode +
                        "-" +
                        parseInt(totalLeadInHigherGroup + 1)
                    );
                    dismissLoader();
                    updateLeadTokenRelationTableCheckPoints(leadData?.paymentId,true,false,leadData?.leadId?.leadId,leadData?.eventId , launchId).then((resp)=>{
                      console.log(resp);
                    }).catch((err)=>{
                      console.log(err);
                    });
                    updateLeadAllStatus(
                      leadData?.leadId?.leadId,
                      "Checkpoint One Cleared"
                    )
                      .then((updatedLeadStatus) => {
                        let obj={
                          leadId:leadData?.leadId?.leadId,
                          leadStatus: `Checkpoint One Cleared`,
                          message:`Band Number ${leadData?.eventTokenId.tokenId?.shortCode +"-" +parseInt(totalLeadInHigherGroup + 1)} assigned to lead.Checkpoint one Cleared by ${loggedInUser.name}(${loggedInUser?.roleId?.title})`
                        }
                        addLeadLogs(obj).then((leadLog)=>{console.log(leadLog)}).catch((err)=>{console.log('leadlog',err)})
                        let QueueObj = {
                          eventId: leadData?.eventId,
                          paymentId:leadData?.paymentId,
                          launchId:launchId,
                          checkPt1:true,
                          checkPt2:false,
                          leadId:leadData?.leadId?.leadId,
                          userId: loggedInUser?.userId,
                          bandNumber: leadData?.eventTokenId.tokenId?.shortCode + "-" + parseInt(totalLeadInHigherGroup + 1)
                        }
                        addQueueLogs(QueueObj).then((queueLogResp) => {console.log(queueLogResp)}).catch((err)=>{console.log('queueLogResp',err)})
                        console.log(updatedLeadStatus);
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  })
                  .catch((err) => {
                    console.log(err);
                    dismissLoader();
                  });
              } else {
                console.log(parseInt(resp[0].num) + 1);
                updateLeadTokenRelationTable(
                  leadData?.paymentId,
                  parseInt(resp[0].num) + 1,
                  leadData?.eventTokenId.tokenId?.shortCode +
                    "-" +
                    (parseInt(resp[0].num) + 1)
                )
                  .then((response) => {
                    updateLeadTokenRelationTableCheckPoints(leadData?.paymentId,true,false,leadData?.leadId?.leadId,leadData?.eventId , launchId).then((resp)=>{
                      console.log(resp);
                    }).catch((err)=>{
                      console.log(err);
                    })
                    setBandNumber(
                      leadData?.eventTokenId.tokenId?.shortCode +
                        "-" +
                        (parseInt(resp[0].num) + 1)
                    );
                    dismissLoader();
                      updateLeadAllStatus(
                        leadData?.leadId?.leadId,
                        "Checkpoint One Cleared"
                      )
                        .then((updatedLeadStatus) => {
                          let obj={
                            leadId:leadData?.leadId?.leadId,
                            leadStatus: `Checkpoint One Cleared`,
                            message:`Band Number ${ leadData?.eventTokenId.tokenId?.shortCode +"-" +(parseInt(resp[0].num) + 1)} assigned to lead.Checkpoint one Cleared by ${loggedInUser.name}(${loggedInUser?.roleId?.title})`}
                          addLeadLogs(obj).then((leadLog)=>{console.log(leadLog)}).catch((err)=>{console.log('leadlog',err)})
                          let QueueObj = {
                            eventId: leadData?.eventId,
                            paymentId:leadData?.paymentId,
                            launchId:launchId,
                            checkPt1:true,
                            checkPt2:false,
                            leadId:leadData?.leadId?.leadId,
                            userId: loggedInUser?.userId,
                            bandNumber:leadData?.eventTokenId.tokenId?.shortCode + "-" + (parseInt(resp[0].num) + 1),
                          }
                          addQueueLogs(QueueObj).then((queueLogResp) => {console.log(queueLogResp)}).catch((err)=>{console.log('queueLogResp',err)})
                          console.log(updatedLeadStatus);
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                  })
                  .catch((err) => {
                    console.log(err);
                    dismissLoader();
                  });
              }
            })
            .catch((err) => {
              console.log(err);
              dismissLoader();
            });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      //Find Total Leads in previous priority group
      findTotalLeadInGroup(leadData?.groupId?.groupPriority, leadData?.eventId,leadData?.eventTokenId?.eventTokenId)
        .then((resp) => {
          let totalLeadInHigherGroup = sumBy(resp.data, function (o) {
            return o.totalLeadsInGroup;
          });
          console.log({ totalLeadInHigherGroup });
          //This is first group
          if (totalLeadInHigherGroup === 0) {
            // checkRunningNumber
            updateLeadTokenRelationTable(
              leadData?.paymentId,
              leadData?.groupId.runningNo + 1,
              leadData?.eventTokenId.tokenId?.shortCode +
                "-" +
                parseInt(leadData?.groupId.runningNo + 1)
            ).then((response) => {
              console.log(response);
              updateRunningNumber(
                leadData?.groupId?.runningNo + 1,
                leadData?.groupId?.groupId
              )
                .then((resp) => {
                  updateLeadTokenRelationTableCheckPoints(leadData?.paymentId,true,false,leadData?.leadId?.leadId,leadData?.eventId , launchId).then((resp)=>{
                    console.log(resp);
                  }).catch((err)=>{
                    console.log(err);
                  })
                  console.log(
                    "runningNumberUpdated",
                    leadData?.groupId?.runningNo + 1
                  );
                })
                .catch((err) => {
                  console.log(err);
                });
              setBandNumber(
                leadData?.eventTokenId.tokenId?.shortCode +
                  "-" +
                  parseInt(leadData?.groupId.runningNo + 1)
              );
              dismissLoader();
              updateLeadAllStatus(
                leadData?.leadId?.leadId,
                "Checkpoint One Cleared"
              )
                .then((updatedLeadStatus) => {
                  let obj={
                    leadId:leadData?.leadId?.leadId,
                    leadStatus: `Checkpoint One Cleared`,
                    message:`Band Number ${ leadData?.eventTokenId.tokenId?.shortCode +"-" +parseInt(leadData?.groupId.runningNo + 1)} assigned to lead.Checkpoint one Cleared by ${loggedInUser.name}(${loggedInUser?.roleId?.title})`}
                  addLeadLogs(obj).then((leadLog)=>{console.log(leadLog)}).catch((err)=>{console.log('leadlog',err)})
                  let QueueObj = {
                    eventId: leadData?.eventId,
                    paymentId:leadData?.paymentId,
                    launchId:launchId,
                    checkPt1:true,
                    checkPt2:false,
                    leadId:leadData?.leadId?.leadId,
                    userId: loggedInUser?.userId,
                    bandNumber:leadData?.eventTokenId.tokenId?.shortCode + "-" + parseInt(leadData?.groupId.runningNo + 1)
                  }
                  addQueueLogs(QueueObj).then((queueLogResp) => {console.log(queueLogResp)}).catch((err)=>{console.log('queueLogResp',err)})
                  console.log(updatedLeadStatus);
                })
                .catch((err) => {
                  console.log(err);
                });
            });
          } else {
            //Not the first one
            console.log("Not first group");
            //Current Running number zero
            if (leadData?.groupId.runningNo === 0) {
              updateLeadTokenRelationTable(
                leadData?.paymentId,
                parseInt(totalLeadInHigherGroup + 1),
                leadData?.eventTokenId.tokenId?.shortCode +
                  "-" +
                  parseInt(totalLeadInHigherGroup + 1)
              ).then((response) => {
                updateLeadTokenRelationTableCheckPoints(leadData?.paymentId,true,false,leadData?.leadId?.leadId,leadData?.eventId , launchId).then((resp)=>{
                  console.log(resp);
                }).catch((err)=>{
                  console.log(err);
                })
                console.log(response);
                updateRunningNumber(
                  totalLeadInHigherGroup + 1,
                  leadData?.groupId?.groupId
                )
                  .then((resp) => {
                    console.log(
                      "runningNumberUpdated",
                      leadData?.groupId?.runningNo + 1
                    );
                  })
                  .catch((err) => {
                    console.log(err);
                  });
                setBandNumber(
                  leadData?.eventTokenId.tokenId?.shortCode +
                    "-" +
                    parseInt(totalLeadInHigherGroup + 1)
                );
                dismissLoader();
                updateLeadAllStatus(
                  leadData?.leadId?.leadId,
                  "Checkpoint One Cleared"
                )
                  .then((updatedLeadStatus) => {
                    console.log(updatedLeadStatus);
                    let obj={
                      leadId:leadData?.leadId?.leadId,
                      leadStatus: `Checkpoint One Cleared`,
                      message:`Band Number ${leadData?.eventTokenId.tokenId?.shortCode +"-" +parseInt(totalLeadInHigherGroup + 1)} assigned to lead.Checkpoint one Cleared by ${loggedInUser.name}(${loggedInUser?.roleId?.title})`
                    }
                    addLeadLogs(obj).then((leadLog)=>{console.log(leadLog)}).catch((err)=>{console.log('leadlog',err)})
                    let QueueObj = {
                      eventId: leadData?.eventId,
                      paymentId:leadData?.paymentId,
                      launchId:launchId,
                      checkPt1:true,
                      checkPt2:false,
                      leadId:leadData?.leadId?.leadId,
                      userId: loggedInUser?.userId,
                      bandNumber: leadData?.eventTokenId.tokenId?.shortCode + "-" + parseInt(totalLeadInHigherGroup + 1)
                    }
                    addQueueLogs(QueueObj).then((queueLogResp) => {console.log(queueLogResp)}).catch((err)=>{console.log('queueLogResp',err)})
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              });
            } else {
              //updated running number assigned to running+1
              updateLeadTokenRelationTable(
                leadData?.paymentId,
                parseInt(leadData?.groupId.runningNo + 1),
                leadData?.eventTokenId.tokenId?.shortCode +
                  "-" +
                  parseInt(leadData?.groupId.runningNo + 1)
              ).then((response) => {
                console.log(response);
                updateRunningNumber(
                  leadData?.groupId?.runningNo + 1,
                  leadData?.groupId?.groupId
                )
                  .then((resp) => {
                    updateLeadTokenRelationTableCheckPoints(leadData?.paymentId,true,false,leadData?.leadId?.leadId,leadData?.eventId , launchId).then((resp)=>{
                      console.log(resp);
                    }).catch((err)=>{
                      console.log(err);
                    })
                    console.log(
                      "runningNumberUpdated",
                      leadData?.groupId?.runningNo + 1
                    );
                  })
                  .catch((err) => {
                    console.log(err);
                  });
                setBandNumber(
                  leadData?.eventTokenId.tokenId?.shortCode +
                    "-" +
                    parseInt(leadData?.groupId.runningNo + 1)
                );
                dismissLoader();
                updateLeadAllStatus(
                  leadData?.leadId?.leadId,
                  "Checkpoint One Cleared"
                )
                  .then((updatedLeadStatus) => {

                    let obj={
                      leadId:leadData?.leadId?.leadId,
                      leadStatus: `Checkpoint One Cleared`,
                      message:`Band Number ${  leadData?.eventTokenId.tokenId?.shortCode +"-" +parseInt(leadData?.groupId.runningNo + 1)} assigned to lead.Checkpoint one Cleared by ${loggedInUser.name}(${loggedInUser?.roleId?.title})`
                    }
                    addLeadLogs(obj).then((leadLog)=>{console.log(leadLog)}).catch((err)=>{console.log('leadlog',err)})
                    let QueueObj = {
                      eventId: leadData?.eventId,
                      paymentId:leadData?.paymentId,
                      launchId:launchId,
                      checkPt1:true,
                      checkPt2:false,
                      leadId:leadData?.leadId?.leadId,
                      userId: loggedInUser?.userId,
                      bandNumber:leadData?.eventTokenId.tokenId?.shortCode + "-" + parseInt(leadData?.groupId.runningNo + 1)
                    }
                    addQueueLogs(QueueObj).then((queueLogResp) => {console.log(queueLogResp)}).catch((err)=>{console.log('queueLogResp',err)})
                    console.log(updatedLeadStatus);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              });
            }
          }
          // console.log({a})
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }



  //Update Lead Status to clear Check Point Two
  function updateLeadStatusToClearCheckPointTwo() {
    updateLeadAllStatus(leadData?.leadId?.leadId, "Checkpoint Two Cleared")
      .then((updatedLeadStatus) => {
        let obj={
          leadId:leadData?.leadId?.leadId,
          leadStatus: `Checkpoint Two Cleared`,
          message:`Checkpoint two cleared by ${loggedInUser.name}(${loggedInUser?.roleId?.title})`
        }
        addLeadLogs(obj).then((leadLog)=>{console.log(leadLog)}).catch((err)=>{console.log('leadlog',err)})
        updateLeadTokenRelationTableCheckPoints(leadData?.paymentId,true,true,leadData?.leadId?.leadId,leadData?.eventId , launchId).then((resp)=>{
          console.log(resp);
          let QueueObj = {
            eventId: leadData?.eventId,
            paymentId:leadData?.paymentId,
            launchId:launchId,
            checkPt1:true,
            checkPt2:true,
            leadId:leadData?.leadId?.leadId,
            userId: loggedInUser?.userId,
            bandNumber:bandNumber,
          }
          addQueueLogs(QueueObj).then((queueLogResp) => {console.log(queueLogResp)}).catch((err)=>{console.log('queueLogResp',err)})
          buttonRes(true);
        }).catch((err)=>{
          console.log(err);
        })
        console.log(updatedLeadStatus);
        handleClose();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //After Scanning get LeadData from EventTokenLeadRelation table
  function getLeadDataEventTokenLead(paymentId) {
    getLeadDataFromPaymentId(paymentId, "Token Payment Complete", eventId).then(
      (resp) => {
        resp.data = resp.data.map((each, index) => ({
          ...each,
          index: index,
          leadName: each?.leadId?.personId?.name,
          cpName: each?.leadId?.cpId?.billingName ?? "-",
          fosName: each?.leadId?.fosId?.name ?? "-",
          sm: each?.leadId?.userId?.name ?? "-",
          displayId:
            "VJ" +
            each?.leadId?.leadDisplayId?.replace(
              each?.leadId?.leadDisplayId?.substring(8, 12),
              "-" + each?.leadId?.leadDisplayId?.substring(8, 12)
            ),
          tokenName: each?.eventTokenId?.tokenId?.name,
          tokenNumber: each?.tokenNumber,
        }));
        setLeadData(resp.data[0]);
        setleadDataFromScan(true);
        if(resp.data[0].checkpt1===false){
          setCheckPoint(1);
          presentLoader();
          // toCheckBandNumberIsPresent(resp.data[0]);
          toCheckAlgoIsUsed(resp.data[0]);
        }else{
          setCheckPoint(2);
        }
        setWebCamModalToggler(false);
        setRespFromQr(resp);
      }
    );
  }
  return (
    <>
      <Modal
        open={open}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={[
          {
            ".MuiBackdrop-root": {
              background: "rgba(193, 201, 210, 0.7)",
            },
          },
        ]}
        disableAutoFocus={true}
      >
        <Box className={cssClasses.modalWrapper}>
          <div className={cssClasses.header}>
            {/* <img src={shuffleIcon} alt="" /> */}
            <h1>Scan QrCode</h1>
            <div className={cssClasses.closeIcon} onClick={handleClose}>
              <Close width={"1.5rem"} height={"1.5rem"} />
            </div>
          </div>
          {(qrPresent === false || leadDataFromScan) && (
            <div className={cssClasses.mainContainer}>
              <div className={cssClasses.mainWrapper}>
                <div className={cssClasses.leftContainer}>
                  <div className={cssClasses.cardTextWrapper}>
                    <p className={cssClasses.leadNameText}>
                      {leadData.leadName}
                    </p>
                    <p className={cssClasses.cardText}>
                      <span>CP: </span> {leadData.cpName}
                    </p>
                    <p className={cssClasses.cardText}>
                      {leadData.tokenNumber}
                    </p>
                    <p className={cssClasses.cardText}>
                      <span>SM: </span> {leadData.sm}
                    </p>
                    <Box
                      display={"flex"}
                      flexDirection={"row"}
                      gap={"1rem"}
                      alignItems={"center"}
                      flex={"0 0 100%"}
                    >
                      <LeadStatusChip
                        style={{
                          color: "#6927DA",
                          backgroundColor: "#EBE9FE",
                        }}
                        label={leadData.tokenName}
                        // icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
                      />
                      {leadData?.leadId?.LeadStatus?.[0]?.status ===
                        "Checkpoint One Cleared" && (
                        <LeadStatusChip
                          style={{
                            color: "#027A48",
                            backgroundColor: "#ECFDF3",
                          }}
                          label={leadData?.leadId?.LeadStatus?.[0]?.status}
                          // icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
                        />
                      )}
                      <p className={cssClasses.cardText}>
                        <span>{leadData.displayId}</span>
                      </p>
                    </Box>
                  </div>
                  <div className={cssClasses.bandNumberWrapper}>
                    <p>Band&nbsp;No.</p>
                    <CustomInput
                      inputType="label"
                      value={
                        leadData?.displayBandNumber
                          ? leadData?.displayBandNumber
                          : bandNumber
                      }
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className={cssClasses.footer}>
            {/* <div><Button style={{ color: "#7F56D9", backgroundColor: "#ffffff" }} btnName={"Download PDF"} clicked={handleClose} /></div> */}
            <div>
              <Button
                style={{ color: "#344054", backgroundColor: "#ffffff" }}
                btnName={"Cancel"}
                clicked={handleClose}
              />
            </div>
            <div>
              <Button
                style={{ color: "#ffffff", backgroundColor: "#007FFF" }}
                clicked={() => {
                   if(leadData?.checkpt1===true&&leadData?.checkpt2===false) {
                    updateLeadStatusToClearCheckPointTwo();
                  }else{
                    handleClose();
                  }
                }}
                btnName={leadData?.checkpt1 === false ? "Done" :leadData?.checkpt2===true? 'Done':"Clear Check Point Two"}
              />
            </div>
          </div>
        </Box>
      </Modal>

      <WebCamModal
        open={webCamModalToggler}
        handleClose={() => {
          setWebCamModalToggler(false);
        }}
        getCode={(resp) => {
          console.log("resp", resp);
          getLeadDataEventTokenLead(resp);
        }}
        parentModalClose={(value) => {
          if (value) {
            handleClose();
          }
        }}
      />
    </>
  );
}

function WebCamModal({ open, handleClose, getCode, parentModalClose }) {
  // let _isNativePlatform = isNativePlatform();

  const [isLoading, setIsLoading] = useState(true);
  const [isCameraFound, setIsCameraFound] = useState(true);
  const [deviceId, setDeviceId] = React.useState({});
  const [devices, setDevices] = React.useState([]);

  const handleDevices = useCallback(
    (mediaDevices) =>
      setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput")),
    [setDevices]
  );
  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(handleDevices);
  }, [handleDevices]);

  useEffect(() => {
    // console.log(devices);
    // console.log(devices.map(m=>({label:m.label,value:m.deviceId})));
    if (devices.length > 0) {
      setDeviceId(devices[0].deviceId);
    }
  }, [devices]);

  const cameraError = async (err) => {
    console.log(err);
    const { state } = await window.navigator.permissions.query({
      name: "camera",
    });
    if (state === "denied") {
      // errorTost("Please allow to access your camera")
    }
    setIsLoading(false);
    setIsCameraFound(false);
  };

  const cameraFound = (res) => {
    if (
      devices
        .map((m) => ({ label: m.label, value: m.deviceId }))
        .some((s) => s.label === "" || s.value === "")
    ) {
      navigator.mediaDevices.enumerateDevices().then(handleDevices);
      setIsCameraFound(res);
      setIsLoading(false);
    } else {
      setIsCameraFound(res);
      setIsLoading(false);
    }
  };
  const webcamRef = useRef(null);

  const [imageBase64, setImageBase64] = useState(null);

  const videoConstraints = {
    facingMode: "user",
  };

  function capture() {
    let _image = webcamRef.current.getScreenshot();
    setImageBase64(_image);
    // console.log("Image --> ",_image);
  }

  function modalClose() {
    setImageBase64(null);
    handleClose();
    parentModalClose(true);
  }

  return (
    <Modal
      open={open}
      onClose={modalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(193, 201, 210, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.header}>
          {/* <img src={shuffleIcon} alt="" /> */}
          <h1>Scan Qr Code</h1>
          <div className={cssClasses.closeIcon} onClick={modalClose}>
            <Close width={"1.5rem"} height={"1.5rem"} />
          </div>
        </div>

        <div
          className={`${cssClasses.mainContainer} ${cssClasses.mainContainerForCameraModal}`}
        >
          <div className={cssClasses.cameraContainer}>
            <img
              src={imageBase64}
              alt=""
              width={imageBase64 ? "100%" : "0px"}
              height={imageBase64 ? "auto" : "0px"}
            />
            <BarcodeScannerComponent
              // width={500}
              // height={500}
              onError={cameraError}
              onUpdate={(err, result) => {
                cameraFound(true);

                if (result) getCode(result.text);
              }}
              // videoConstraints={{facingMode: { exact: "environment" }}}
            />
          </div>
        </div>

        {/* <div className={cssClasses.footer}>
      
          <div>
            <Button
              style={{
                color: "#0070E0",
                backgroundColor: "#ffffff",
                border: "1px solid #0070E0",
              }}
              btnName={imageBase64 ? "Re-Capture" : "Capture"}
              clicked={() => {
                if (imageBase64) {
                  setImageBase64(null);
                } else {
                  capture();
                }
              }}
            />
          </div>
          <div>
            <Button
              style={{ color: "#ffffff", backgroundColor: "#007FFF" }}
              btnName={"Save"}
              disable={imageBase64 ? false : true}
            />
          </div>
        </div> */}
      </Box>
    </Modal>
  );
}
